<template>
    <section class="farmerContainer">
        <div class="container">
            <div class="offset-lg-1 col-lg-10 loading">
                <div class="breadcrumbs">
                    <ul class="breadcrumbs-list">
                        <li class="breadcrumbs-list-item">
                            <a href="#">Orders</a>
                        </li>
                        <li class="breadcrumbs-list-item">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0.528514 0.528636C0.788864 0.268287 1.21097 0.268287 1.47132 0.528636L5.47132 4.52864C5.73167 4.78899 5.73167 5.2111 5.47132 5.47145L1.47132 9.47145C1.21097 9.7318 0.788864 9.7318 0.528514 9.47145C0.268165 9.2111 0.268165 8.78899 0.528514 8.52864L4.05711 5.00004L0.528514 1.47145C0.268165 1.2111 0.268165 0.788986 0.528514 0.528636Z"
                                    fill="#E0C7B1" />
                            </svg>
                        </li>
                        <li class="breadcrumbs-list-item">
                            <router-link :to="{name: 'offtaker.shippingdetails'}" class="breadcrumbs-active">Shipping</router-link>
                        </li>
                        <li class="breadcrumbs-list-item">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0.528514 0.528636C0.788864 0.268287 1.21097 0.268287 1.47132 0.528636L5.47132 4.52864C5.73167 4.78899 5.73167 5.2111 5.47132 5.47145L1.47132 9.47145C1.21097 9.7318 0.788864 9.7318 0.528514 9.47145C0.268165 9.2111 0.268165 8.78899 0.528514 8.52864L4.05711 5.00004L0.528514 1.47145C0.268165 1.2111 0.268165 0.788986 0.528514 0.528636Z"
                                    fill="#E0C7B1" />
                            </svg>
                        </li>
                        <li class="breadcrumbs-list-item">
                            <a href="#" @click="checkAddress">Payment</a>
                        </li>
                        <li class="breadcrumbs-list-item">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0.528514 0.528636C0.788864 0.268287 1.21097 0.268287 1.47132 0.528636L5.47132 4.52864C5.73167 4.78899 5.73167 5.2111 5.47132 5.47145L1.47132 9.47145C1.21097 9.7318 0.788864 9.7318 0.528514 9.47145C0.268165 9.2111 0.268165 8.78899 0.528514 8.52864L4.05711 5.00004L0.528514 1.47145C0.268165 1.2111 0.268165 0.788986 0.528514 0.528636Z"
                                    fill="#E0C7B1" />
                            </svg>
                        </li>
                        <li class="breadcrumbs-list-item">
                            <!-- <a href="#" >Confirmation</a> -->
                            Confirmation
                        </li>
                        <li class="breadcrumbs-list-item">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0.528514 0.528636C0.788864 0.268287 1.21097 0.268287 1.47132 0.528636L5.47132 4.52864C5.73167 4.78899 5.73167 5.2111 5.47132 5.47145L1.47132 9.47145C1.21097 9.7318 0.788864 9.7318 0.528514 9.47145C0.268165 9.2111 0.268165 8.78899 0.528514 8.52864L4.05711 5.00004L0.528514 1.47145C0.268165 1.2111 0.268165 0.788986 0.528514 0.528636Z"
                                    fill="#E0C7B1" />
                            </svg>
                        </li>
                    </ul>
                </div>
                <loading v-if="loadingAddress" />
                <span v-if="(addresses.length === 0 && !loadingAddress) || edit">
                    <fill-address :order="order" :addresses="addresses" :creatingOrderPayment="creatingOrder" />
                </span>

                <span v-if="addresses.length !== 0 && !loadingAddress && !edit">
                    <Address :addresses="addresses" @changeContact="changeContact" :creatingOrderPayment="creatingOrder" :order="order" />
                </span>
                
            </div>
        </div>
        
    </section>
</template>

<script>
import { mapState } from 'vuex';
import FillAddress from '@/components/off-taker/order/FillAddress';
import Address from '@/components/off-taker/order/Address';

export default {
    data() {
        return {
           addresses: [],
           loadingAddress: false,
           edit: false,
           order: '',
           creatingOrder: false,
        }
    },
    computed: {
        ...mapState('offtaker',['cart']),
        subTotal() {
            return this.cart.reduce((sum, item) => {
                return sum + (item.crop.kg_price * item.quantity)
            }, 0)
        },
        tax() {
            return this.subTotal * 0.05
        },
        total() {
            return this.subTotal + this.tax
        },
        orderId() {
            return this.$route.params.id
        }
        
    },
    methods: {
        
        getAddress() {
            this.loadingAddress = true;
            this.$http.get('addresses')
            .then((response) => {
                this.addresses = response.data
                this.edit = false;
                this.$log(response.data)
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.loadingAddress = false;
            })
        },
        createOrder() {
            this.creatingOrder = true;
            const obj = {
                shipping_amount: 0,
                tax_amount: this.tax
            }
            this.$http.post('crop_orders', obj)
            .then((response) => {
                this.order = response.data;
                this.$log('Order created ', response.data)
                this.$router.push({
                    name: 'offtaker.orderpayment',
                    params: {
                        id: response.data.id
                    }
                })
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.creatingOrder = false;
            })
        },
        getOrder(orderId) {
            this.gettingOrder = true;
            this.$http.get(`crop_orders/${orderId}`)
            .then((response) => {
                this.order = response.data;
                this.$log('Order created ', response.data)
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.gettingOrder = true;
            })
        },
        checkAddress() {
            if(this.addresses.length === 0) {
                this.$toastr.warning('Please fill in your address')
            } else {
                if(this.orderId === 'false') {
                    this.createOrder();
                } else {
                    this.$router.push({
                        name: 'offtaker.orderpayment',
                        params: {
                            id: this.orderId
                        }
                    })
                }
            }
        },
        
        changeContact() {
            this.edit = !this.edit;
        }
    },
    beforeRouteEnter(to, from, next) {
        if(from.params.id !== 'false' && to.params.id !== 'false') {
            next(vm => {
                vm.getOrder(from.params.id)
            })
        }
        next()
    },
    created() {
        this.getAddress()
        // if(this.orderId !== 'false') {
        //     this.getOrder()
        // }
        // this.createOrder()
    },
    components: {
        FillAddress,
        Address
    }
}
</script>